import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { CollateralBaseUrl } from '../../../utils/BaseUrl';
// import { getThumbnailImage } from '../../../utils/Helperfunctions';

class RenderReviews extends Component {
  state = {
    showMoreLength:5,
    readMore:false
  }

  readMore = () => {
    const {showMoreLength,readMore} = this.state;
    const { reviews } = this.props;

    this.setState({
      readMore: !readMore,
      showMoreLength:(showMoreLength < reviews.length) ?  reviews.length : 2,
    })
  }
  
  render() {
    const { reviews } = this.props
    const {showMoreLength,readMore} = this.state;
    
    return (
      <section>
        {
          (reviews.length < 1) ? <></>
            :
            <>
              {
                reviews.slice(0,showMoreLength).map((r, k) => {
                  let /* image,*/ projectId, title, rating, feedback, reviewer, reviewerDesignation, reviewerCompany;
                  const isTypeProject = r.type === 'upload_project';
                  if(isTypeProject){
                    // let imageIndex = r?.project_data?.images_or_links && r?.project_data?.images_or_links.findIndex((item) => item.value !== "");
                    // image = r?.project_data?.images_or_links && r?.project_data.images_or_links.some((el) => el.isThumbnail === 1) ? r.project_data.images_or_links.filter((el) => el.isThumbnail === 1)[0] : r?.project_data?.images_or_links && r?.project_data?.images_or_links?.[imageIndex];
                    projectId = r?.project_data._id;
                    title = r?.project_data?.title;
                    rating = r?.data_review?.review;
                    feedback = r?.data_review?.feedback;
                    reviewer = r?.data_review?.name;
                    reviewerDesignation = r?.data_review?.designation;
                    reviewerCompany = r?.data_review?.company_name;                    
                  } else {
                    // image = {value: CollateralBaseUrl + r?.Collateral_image}
                    projectId = r?.review?.post_project_id;
                    title = r?.project_name;
                    rating = r?.review?.rating;
                    feedback = r?.review?.description;
                    reviewer = r?.Client_name;
                    reviewerDesignation = r?.designation;
                    reviewerCompany = r?.company_name;
                  }
                  
                  return (
                    <div key={k} className="custom_form account-setting mob-p-10">
                      <div className="card-body border-bottom">
                        <div className="row m-0">
                          <div className="col-sm-12 px-4 py-3 mob-pt-15">
                            <div className="w-100 rating">
                              <h2 className="text-capitalize d-flex justify-content-between mob-font-14">
                              <span className='fw_800 font-16'>{title} </span>
                                {!isTypeProject && <p className='d-inline-block font-13 text-success mob-font-12 mb-0'>{"Completed on IndieFolio"}</p>}
                              </h2>
                            </div>
                            <div className="text-lg-center recommendation review_box"
                              data-toggle="modal"
                              data-target="#editWorkSection"
                              onClick={(e) => {
                                isTypeProject && this.props.OpenPopup('ViewModal');
                                isTypeProject && this.props.LoadProjectData(projectId);
                              }}
                            >
                              <div className="d-inline-block">
                                <span><i className={`fas fa-star font-12 mr-1  ${rating >= 1 ? 'text_light_green' : 'light-gray'} `}></i></span>
                                <span><i className={`fas fa-star font-12 mr-1  ${rating >= 2 ? 'text_light_green' : 'light-gray'} `}></i></span>
                                <span><i className={`fas fa-star font-12 mr-1  ${rating >= 3 ? 'text_light_green' : 'light-gray'} `}></i></span>
                                <span><i className={`fas fa-star font-12 mr-1  ${rating >= 4 ? 'text_light_green' : 'light-gray'} `}></i></span>
                                <span><i className={`fas fa-star font-12 ${rating === 5 ? 'text_light_green' : 'light-gray'} `}></i></span>
                              </div>
                              <div className="font-14 ml-2">
                                <span className="font-weight-600">{rating}</span><span className="font-12 font-weight-600">/5</span>
                              </div>
                                {/* {image ? <RenderImage image={image} /> : null} */}
                            </div>
                            <p>
                                {feedback && <q className="quotes mob-font-14">{feedback}</q>}
                              </p>
                            <div className="w-100 d-flex align-items-center">
                              <div className='d-flex align-items-center'>
                                <h2 className="text-capitalize m-0 font-13 mob-font-12">{reviewer}</h2>
                                {reviewerDesignation && reviewerCompany &&
                                  <span className="profile-subTitle font-12 mob-font-11 ml-2 text-capitalize">
                                    {reviewerDesignation}, {reviewerCompany}
                                  </span>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
              }
              {(reviews.length > 2) ?
              <div className="text-center">
                <p className="mt-12 view-more">
                  <span className="font-12 text-primary font-weight-600 p-1 bg-white" id=""  onClick={this.readMore}>
                    <i className={`fas  ${readMore === true ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i> {readMore ? 'Show less' : 'Show more'}
                  </span>
                </p>
              </div>
              :<></>
            } 
            </>
        }
      </section>
    )
  }
}
const mapDispatch = (dispatchEvent) => ({
  OpenPopup: (text) => dispatchEvent({ type: 'OPEN_POPUP_SAGA', payload: { Component: text } }),
  LoadProjectData: (id) => dispatchEvent({ type: 'LOAD_PROJECT_DATA', payload: { id } }),
});
export default connect(null, mapDispatch)(RenderReviews);


// const RenderImage = ({image}) => {
//   const [thumbnail, setThumbnail] = useState(null)

//   useEffect(() => {
//     const getThumbnailImageFunc = async (u) => {
//       const url = await getThumbnailImage(u, true);
//       setThumbnail(url)
//     }
//     if(image.type === 'url'){
//       getThumbnailImageFunc(image.value)
//     } else {
//       setThumbnail(image.value)
//     }
//   }, [])

//   return( 
//     <div className="recommendation_image">
//       <img alt="" src={thumbnail} className="img-fluid" />
//     </div>
//   )
// }